import { io } from 'socket.io-client'
import { resolveSocketBaseUrl } from '@/shared/socket/socketConfig'

let socket = null
let connectPromise = null

export function getSocket() {
  return socket
}

export function isSocketConnected() {
  return Boolean(socket?.connected)
}

export function connectSocket() {
  if (socket?.connected) {
    return Promise.resolve(socket)
  }

  if (connectPromise) {
    return connectPromise
  }

  if (socket) {
    socket.removeAllListeners()
    socket.disconnect()
    socket = null
  }

  const url = resolveSocketBaseUrl()
  if (url == null) {
    return Promise.resolve(null)
  }

  connectPromise = new Promise((resolve, reject) => {
    const instance = io(url, {
      withCredentials: true,
      autoConnect: true,
    })

    const onReady = () => {
      cleanup()
      socket = instance
      connectPromise = null
      resolve(socket)
    }

    const onFail = (error) => {
      cleanup()
      instance.disconnect()
      connectPromise = null
      reject(error)
    }

    const cleanup = () => {
      instance.off('connect', onReady)
      instance.off('connect_error', onFail)
    }

    instance.once('connect', onReady)
    instance.once('connect_error', onFail)
  })

  return connectPromise
}

export function disconnectSocket() {
  if (socket) {
    socket.removeAllListeners()
    socket.disconnect()
    socket = null
  }
  connectPromise = null
}

export function emit(event, payload) {
  socket?.emit(event, payload)
}

export function on(event, handler) {
  socket?.on(event, handler)
}

export function off(event, handler) {
  socket?.off(event, handler)
}
